import { NgModule } from '@angular/core';
import { NgxFigmaComponent } from './ngx-figma.component';

@NgModule({
  declarations: [NgxFigmaComponent],
  imports: [
  ],
  exports: [NgxFigmaComponent]
})
export class NgxFigmaModule { }
